import { render, staticRenderFns } from "./TravelCostList.vue?vue&type=template&id=8c0824c0&scoped=true&"
import script from "./TravelCostList.vue?vue&type=script&lang=js&"
export * from "./TravelCostList.vue?vue&type=script&lang=js&"
import style0 from "./TravelCostList.vue?vue&type=style&index=0&id=8c0824c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0824c0",
  null
  
)

export default component.exports